









import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { RouteImage } from '@/models/route';
import { urlize } from '@/utils';

@Component
export default class RouteSlideImage extends Vue {

    @Prop(Object) public model: RouteImage;

    get imageUrl() {
        return urlize(this.model.image.medium);
    }
}
